import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const useBootstrap = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    api.bootstrap()
      .then((d) => { if (alive) setData(d); })
      .catch((e) => { if (alive) setError(e); });
    return () => { alive = false; };
  }, []);

  return { data, error, loading: !data && !error };
};
